import React from 'react'
import classNames from 'classnames'
import { CMSButton } from '@/ui/components/CMSButton'
import { Button } from '@/ui/atoms/Button'
import { Icon } from '@/ui/atoms/Icon'
import { CMSLink } from '@/ui/components/CMSLink'

interface NavItemProps {
  href?: string
  label?: string
  onClick?: () => void
  isActive?: boolean
  isMobile?: boolean
  button?: any // For CMSButton props
  className?: string
  isDropdown?: boolean
  showNextIcon?: boolean
  showBackIcon?: boolean
}

export const NavItem: React.FC<NavItemProps> = ({
  href,
  label,
  onClick,
  isActive,
  isMobile = false,
  button,
  className,
  isDropdown,
  showNextIcon,
  showBackIcon,
}) => {
  const baseClasses = classNames(
    'canhover:hover:bg-white canhover:hover:bg-opacity-5 canhover:hover:no-underline w-full lg:w-auto',
    '!text-text-inverted py-2 lg:py-4 rounded-sm',
    {
      '!text-body-M-semibold block px-2 flex justify-between items-center w-full text-text-inverted':
        isMobile,
      '!justify-start': isMobile && showBackIcon,
      'text-label-XS-semibold px-5': !isMobile,
      'bg-base-transparent-10 bg-white bg-opacity-10': isActive,
    },
    className,
  )

  if (button) {
    return (
      <CMSButton
        {...button}
        className={baseClasses}
        appearance={'ghostInverted'}
        size={isMobile ? 'lg' : 'sm'}
        showIconLeft={showBackIcon}
        showIconRight={showNextIcon}
      />
    )
  }

  if (href) {
    return (
      <CMSLink
        link={{
          type: 'custom',
          url: href,
          newTab: false,
        }}
        label={label}
        className={baseClasses}
        size={isMobile ? 'lg' : 'sm'}
        showIconLeft={showBackIcon}
        showIconRight={showNextIcon}
      />
    )
  }

  return (
    <Button
      variant={'ghostInverted'}
      size={isMobile ? 'lg' : 'sm'}
      className={baseClasses}
      onClick={onClick}
    >
      {showBackIcon && <Icon name={'arrow-left'} className={'!size-5'} />}
      {label}
      {isDropdown && (
        <Icon className={`${isMobile ? '-rotate-90 !size-6' : ''}`} name={'arrow-down'} />
      )}
      {showNextIcon && <Icon name={'arrow-left'} className={'!size-5 rotate-180 ml-auto'} />}
    </Button>
  )
}
